import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Pheme admin module — `/pheme` on console.francisquini.ai.
 *
 * Single operator dashboard. Message editing/catalog legacy screens were
 * removed from Ariadne; Pheme remains the source of truth behind the admin API.
 *
 * Surface is `'admin'` — registered only on the console host. Defence-in-
 * depth: each page also wraps `<RequireAdmin>` so a misconfigured router
 * can't leak admin UI to product users.
 *
 * Spec: arkheus/docs/specs/pheme/facts-snapshot-rules-console.md §5.
 */
export const manifest: ModuleManifest = {
  module_id: 'pheme',
  display_name: 'Pheme',
  surface: 'admin',
  routes: [
    {
      path: '/pheme',
      component: () =>
        import('@/routes/_app/pheme').then((m) => ({
          default: m.PhemeHomePage,
        })),
      title: 'Pheme — Dashboard',
      permissions: [],
    },
  ],
}
